/* DIORAO — global tile hover handler for video autoplay + variant buttons.
   Attached to window load; uses event delegation so it works for
   tiles rendered anywhere (collection grid, homepage fresh-products, related, etc.) */
(function(){
  if (window.__dioraoTileHoverInit) return;
  window.__dioraoTileHoverInit = true;

  function init(){
    document.querySelectorAll('.diorao-col__tile--has-video').forEach(function(tile){
      if (tile.__dioraoBound) return;
      tile.__dioraoBound = true;
      var video = tile.querySelector('[data-tile-video]');
      if (!video) return;
      var loaded = false;
      tile.addEventListener('mouseenter', function(){
        if (!loaded) { video.load(); loaded = true; }
        var p = video.play();
        if (p && p.catch) p.catch(function(){ /* autoplay blocked — ignore */ });
      });
      tile.addEventListener('mouseleave', function(){
        video.pause();
        try { video.currentTime = 0; } catch(e){}
      });
      // Touch devices — tap to preview for 3s, then stop
      tile.addEventListener('touchstart', function(){
        if (!loaded) { video.load(); loaded = true; }
        video.play().catch(function(){});
      }, { passive: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // Re-init after section re-render (theme editor)
  document.addEventListener('shopify:section:load', init);
})();
